module.exports = __webpack_public_path__ + "img/peopleHeartIcon.c9a42a96.svg";